import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import React from 'react';
import { ROUTER_PATH } from 'router/const/routerPath.const';
import { getCurrentDomain } from 'router/utils/getRedirectLink';

import {
  LoginContent,
  PositionCard,
  CardImage,
  CardForm,
  LoginHeader,
  HeaderLogo,
  BackgroundLayer,
  DecorativeLayer,
  CardBody,
} from '../styles';
import { LoginForm } from './LoginForm';

const { logoDark, logoWhite } = STATIC_IMAGE_URLS;

export const Login: React.FC = () => {
  const domain = getCurrentDomain();

  if (domain === process.env.REACT_APP_SSO_DOMAIN && !window.location.search.includes('IdP')) {
    const currentSubdomain = window.location.host.split('.')[0];
    const currentSchema = window.location.protocol;
    const urlParams = window.location.search;

    if (process.env.NODE_ENV === 'development') {
      window.location.replace(
        `${currentSchema}//${currentSubdomain}.${process.env.REACT_APP_DOMAIN}:${process.env.WDS_SOCKET_PORT}${ROUTER_PATH.LOGIN}${urlParams}`,
      );
    } else {
      window.location.replace(
        `${currentSchema}//${currentSubdomain}.${process.env.REACT_APP_DOMAIN}${ROUTER_PATH.LOGIN}${urlParams}`,
      );
    }
  }

  return (
    <>
      <LoginHeader>
        <HeaderLogo src={logoWhite} alt="Streamline Logo" />
      </LoginHeader>
      <BackgroundLayer />
      <DecorativeLayer />
      <LoginContent>
        <PositionCard>
          <CardForm>
            <CardImage src={logoDark} />
            <CardBody>
              <LoginForm />
            </CardBody>
          </CardForm>
        </PositionCard>
      </LoginContent>
    </>
  );
};
